import { jsx as _jsx } from "react/jsx-runtime";
import { _values, Filter, resolveContent, sortArray } from '@nu-art/ts-common';
import { TS_DropDown } from '../TS_Dropdown/index.js';
import { SimpleListAdapter } from '../adapter/Adapter.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { resolveEditableError } from '../types.js';
// const defaultQueryFilter = () => true;
export class GenericDropDownV3 extends ComponentSync {
    static prepareEditable = (mandatoryProps) => {
        return (props) => {
            const { editable, prop, ...restProps } = props;
            const onSelected = async (item) => {
                await editable.updateObj({ [prop]: item?._id });
            };
            return _jsx(GenericDropDownV3, { error: resolveEditableError(props), ...resolveContent(mandatoryProps), ...restProps, onSelected: async (item) => {
                    if (props.onSelected)
                        return props.onSelected(item, onSelected);
                    return onSelected(item);
                }, selected: editable.item[prop] });
        };
    };
    static prepareSelectable = (mandatoryProps) => {
        return (props) => _jsx(GenericDropDownV3, { ...resolveContent(mandatoryProps), ...props });
    };
    static prepare = (mandatoryProps) => {
        return {
            editable: this.prepareEditable(mandatoryProps),
            selectable: this.prepareSelectable(mandatoryProps),
        };
    };
    static prepareSelectable_DBPointers = (mandatoryProps) => {
        const _mandatoryProps = resolveContent(mandatoryProps);
        return (props) => _jsx(GenericDropDownV3, { ..._mandatoryProps, ...props, itemResolver: () => {
                const modules = _values(_mandatoryProps.pointerProps).map(val => val.module);
                return modules.map(module => module.cache.all().map(dbItem => ({ dbKey: module.dbDef.dbKey, item: dbItem }))).flat();
            }, renderer: (item) => _mandatoryProps.pointerProps[item.dbKey].renderer(item), mapper: (item) => _mandatoryProps.pointerProps[item.dbKey].mapper(item), 
            // @ts-ignore
            module: undefined });
    };
    static prepareEditable_DBPointers = (mandatoryProps) => {
        return (props) => {
            const _mandatoryProps = resolveContent(mandatoryProps);
            const { editable, prop, ...restProps } = props;
            const onSelected = async (item) => {
                await editable.updateObj({ [prop]: item._id });
            };
            return _jsx(GenericDropDownV3, { error: resolveEditableError(props), ..._mandatoryProps, ...restProps, onSelected: async (item) => {
                    if (props.onSelected)
                        return props.onSelected(item, onSelected);
                    return onSelected(item);
                }, selected: editable.item[prop], 
                // @ts-ignore
                module: undefined });
        };
    };
    static prepare_DBPointers = (mandatoryProps) => {
        return {
            editable: this.prepareEditable_DBPointers(mandatoryProps),
            selectable: this.prepareSelectable_DBPointers(mandatoryProps),
        };
    };
    deriveStateFromProps(nextProps) {
        const state = {};
        const items = this.props.itemResolver?.() || nextProps.module.cache.allMutable();
        if (!nextProps.queryFilter)
            state.items = items;
        else {
            state.items = items.filter(nextProps.queryFilter);
            if (state.items.length === 0 && nextProps.ifNoneShowAll === true)
                state.items = items;
        }
        //Sort Items by sort function or object keys
        state.items = nextProps.sortBy?.reduce((toRet, sortBy) => {
            return sortArray(state.items, typeof sortBy === 'function' ? sortBy : item => item[sortBy]);
        }, state.items) || state.items;
        state.error = nextProps.error;
        //Set selected item
        state.selected = this.getSelected(nextProps.module, nextProps.selected);
        state.filter = new Filter(nextProps.mapper);
        state.adapter = SimpleListAdapter(state.items, props => nextProps.renderer(props.item));
        return state;
    }
    getSelected(module, selectMethod) {
        switch (typeof selectMethod) {
            case 'string':
                return module.cache.unique(selectMethod);
            case 'function':
                return selectMethod();
            case 'object':
                if (!Array.isArray(selectMethod))
                    return selectMethod;
        }
        return undefined;
    }
    render() {
        return _jsx(TS_DropDown, { ref: this.props.dropdownRef, id: this.props.id, innerRef: this.props.innerRef, tabIndex: this.props.tabIndex, error: this.state.error, className: this.props.className, placeholder: this.props.placeholder || 'Choose one', inputValue: this.props.inputValue, adapter: this.state.adapter, filter: this.state.filter, selected: this.state.selected, onNoMatchingSelectionForString: this.props.onNoMatchingSelectionForString, onSelected: this.props.onSelected, noOptionsRenderer: this.props.noOptionsRenderer, caret: this.props.caret, selectedItemRenderer: this.props.selectedItemRenderer, boundingParentSelector: this.props.boundingParentSelector, renderSearch: this.props.renderSearch, limitItems: this.props.limitItems, hidePlaceholderOnOpen: this.props.hidePlaceholderOnOpen, unselectLabel: this.props.unselectLabel, canUnselect: this.props.canUnselect, disabled: this.props.disabled });
    }
}
//# sourceMappingURL=GenericDropDownV3.js.map